
import './App.css';
import Adminpage from './components/Adminpage';

function App() {
  return (
    <section className='App'>
     <Adminpage />
    </section>
  );
}

export default App;
